import { Button, MenuItem, Select, FormControl, InputLabel, Tooltip } from "@mui/material";
import { format } from "date-fns";
import AddIcon from '@mui/icons-material/Add';



/** 
 * @param {displayStepper} displayStepper 
 * @param {setDisplayStepper} prsetDisplayStepperops 
 * @param {defaultFinancial} defaultFinancial
 * @param {financials} financials
 * @param {} selectedFid
 * @param{} setSelectedFid
 * @param{} onEnterNew - Optional callback for custom handling of new entry creation
 * @param{} divisions - Array of available divisions
 * @param{} selectedDivision - Currently selected division
 * @param{} setSelectedDivision - Function to set the selected division
 * 
 */
function FinancialPicker(props) {

    const showStepper = () => {
        props.setDisplayStepper(!props.displayStepper);
    };

    // Helper to get available divisions from props or fall back to peers
    const getAvailableDivisions = () => {
        if (props.divisions && props.divisions.length > 0) {
            return props.divisions;
        }
        if (props.peers && props.peers.length > 0) {
            return props.peers.map(peer => peer.division);
        }
        return [];
    };

    // Helper to sort financials by fiscal year and report date
    const sortFinancials = (financials) => {
        // Check if we have valid data
        if (!financials || financials.length === 0) return [];
        
        return [...financials].sort((a, b) => {
            // First sort by fiscalEnd year (descending - newest first)
            const yearA = a.fiscalEnd ? new Date(a.fiscalEnd).getFullYear() : 0;
            const yearB = b.fiscalEnd ? new Date(b.fiscalEnd).getFullYear() : 0;
            
            if (yearB !== yearA) {
                return yearB - yearA; // Most recent year first
            }
            
            // Then sort by reportDate within the same year (ascending)
            const dateA = a.reportDate ? new Date(a.reportDate) : new Date(0);
            const dateB = b.reportDate ? new Date(b.reportDate) : new Date(0);
            
            return dateA - dateB;
        });
    };

    const handleSelect = (e) => {
        // Only allow selection if a division is selected
        if (!props.selectedDivision) {
            return;
        }
        props.setSelectedFid(e.target.value);
        //Select the correct financial
        props.setSelectedFinancial(props.financials.find((f) => f.fiscalInputId === e.target.value));
        console.log(e.target.value);
        showStepper();
    }

    const handleDivisionChange = (e) => {
        if (props.setSelectedDivision) {
            props.setSelectedDivision(e.target.value);
        }
    }

    const enterNew = () => {
        // Only allow creating new if a division is selected
        if (!props.selectedDivision) {
            return;
        }
        if (props.onEnterNew) {
            // Use custom handler if provided
            props.onEnterNew();
        } else {
            // Default behavior - preserve the selected division
            const newFinancial = {...props.defaultFinancial, division: props.selectedDivision};
            props.setSelectedFinancial(newFinancial);
            showStepper();
        }
    };

    // const editExisting = () => {
    //     props.setSelectedFinancial(props.financials.find((f) => f.financialInputId === props.selectedFid));
    //     showStepper();
    // };

    // Get available divisions for rendering
    const availableDivisions = getAvailableDivisions();
    console.log('getAvailableDivisions result:', availableDivisions);
    console.log('props.divisions:', props.divisions);
    console.log('props.peers:', props.peers);

    if (props.financials !== null && props.financials !== undefined && props.financials.length > 0) {
        return (
            //create a select and when that changes go ahead and update selected finiancial id
            <>
                <div>
                    <p>Select an existing financial report to edit or select the Create New button to start a new report.</p>
                    
                    <div className="formRow" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: '16px', flexWrap: 'wrap' }}>
                      {availableDivisions.length > 0 && props.setSelectedDivision && (
                          <div className="formGroup" style={{ flex: '1', minWidth: '200px' }}>
                                  <Tooltip title="The division for which the company is reporting the data. If the company does not have multiple divisions, select the trade the company is most active." arrow placement="top">
                                      <FormControl fullWidth>
                                          <InputLabel id="division-select-label">Select Division</InputLabel>
                                          <Select
                                              labelId="division-select-label"
                                              id="division-select"
                                              value={props.selectedDivision || ''}
                                              label="Select Division"
                                              onChange={handleDivisionChange}
                                          >
                                              <MenuItem value="">All Divisions</MenuItem>
                                              {availableDivisions.map((division, index) => (
                                                  <MenuItem key={index} value={division}>{division}</MenuItem>
                                              ))}
                                          </Select>
                                      </FormControl>
                                  </Tooltip>
                          </div>
                      )}
                      <div className="formGroup" style={{ flex: '2', minWidth: '300px' }}>
                              <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  label={props.selectText}
                                  onChange={handleSelect}
                                  value={
                                      (props.selectedFid === undefined ||
                                          props.selectedFid === null) ? '0' :
                                          props.selectedFid
                                  }
                                  fullWidth
                                  disabled={!props.selectedDivision}
                              >
                                  <MenuItem key="0" value="0">
                                      {props.selectedDivision ? "Select Year and Statement" : "Please select a division first"}
                                  </MenuItem>
                                  {
                                      sortFinancials(props.financials)
                                          .map((f) => {
                                          return <MenuItem key={f.fiscalInputId} value={f.fiscalInputId}>
                                            {f.isYTD ? (
                                                <>
                                                    {f.fiscalStart ? format(new Date(f.fiscalStart), 'yyyy') : ''} 
                                                    {f.isYTD ? ' - ' + format(new Date(f.fiscalStart), 'MMMM')+" (YTD)" : ""} 
                                                    {f.division ? ` - ${f.division}` : ''}
                                                </>
                                            ) : (
                                                <>
                                                    {f.fiscalEnd ? format(new Date(f.fiscalEnd), 'yyyy') : ''} 
                                                    {f.division ? ` - ${f.division}` : ''}
                                                </>
                                            )}
                                          </MenuItem>
                                      })
                                  };

                              </Select>
                          </div>
                          <div className="formGroup" style={{ display: 'flex', alignItems: 'flex-end', marginTop: availableDivisions.length > 0 ? '0' : '16px' }}>
                              {props.allowNew &&
                                  <Button 
                                      variant="outlined" 
                                      onClick={enterNew} 
                                      startIcon={<AddIcon/>}
                                      disabled={!props.selectedDivision}
                                  >
                                      Create New
                                  </Button>
                              }
                              {/* <Button variant="contained" onClick={editExisting}>Edit</Button> */}
                          </div>
                    </div>
                </div>

            </>);
    }
    else {
        return (
            <>
                <div>
                    <p>No financial reports found. Create a new one to get started.</p>
                    <div className="formRow" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: '16px', flexWrap: 'wrap' }}>
                        {availableDivisions.length > 0 && props.setSelectedDivision && (
                            <div className="formGroup" style={{ flex: '1', minWidth: '200px' }}>
                                <Tooltip title="The division for which the company is reporting the data. If the company does not have multiple divisions, select the trade the company is most active." arrow placement="top">
                                    <FormControl fullWidth>
                                        <InputLabel id="division-select-label">Select Division</InputLabel>
                                        <Select
                                            labelId="division-select-label"
                                            id="division-select"
                                            value={props.selectedDivision || ''}
                                            label="Select Division"
                                            onChange={handleDivisionChange}
                                        >
                                            <MenuItem value="">All Divisions</MenuItem>
                                            {availableDivisions.map((division, index) => (
                                                <MenuItem key={index} value={division}>{division}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Tooltip>
                            </div>
                        )}
                        <div className="formGroup" style={{ display: 'flex', alignItems: 'flex-end' }}>
                            <Button 
                                variant="outlined" 
                                onClick={enterNew} 
                                startIcon={<AddIcon/>}
                                disabled={!props.selectedDivision}
                            >
                                Create New
                            </Button>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default FinancialPicker;